export class OfferNumber {
    constructor(public data?: {
        ID?: Number,
        ProductType?: Number,
        Prefix?: String,
        OfferNumberStart?: Number,
        OfferNumberEnd?: Number,
        Sufix?: String,
        Active?: Boolean
    }) { }
}